import {
  getAuditDetails,
  getAuditFieldInfo,
  AuditService,
  AuditActionType,
} from 'shared/userAudit/audit-constants';
import { Operation, AuditDetails } from 'data/types';
import { AfFilter } from 'data/afFilter/afFilter.types';

export function getAuditDetailsToSubmit(
  dialedDigitExtractionServerData: AfFilter,
  originalDigitExtractionServerFormData: AfFilter | null,
  isAuditEnabled: boolean,
  userId: string,
  userName: string,
  operation: Operation,
): AuditDetails {

  const actionType = AuditActionType.SECURITY_INFO_ADD;
  const isEdit = false;

  const auditDetails = getAuditDetails(
    isAuditEnabled,
    userId,
    userName,
    getAuditFieldInfo(dialedDigitExtractionServerData, null, isEdit, originalDigitExtractionServerFormData),
    dialedDigitExtractionServerData.fgId,
    AuditService.SECURITY_INFO,
    actionType,
  );
  return auditDetails as AuditDetails;
}
